import React, { useEffect, useRef, useState } from "react";

export default function useIntersectionOnce(root = null, rootMargin = "0px", threshold = 0) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (visible) return;
    const node = ref.current;
    if (!node) return;

    // Fallback: if no IntersectionObserver (or SSR), render immediately
    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { root, rootMargin, threshold }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [root, rootMargin, threshold, visible]);

  return [ref, visible];
}
